// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__AwSIQ","span":"Navigation_span__Ti+60"};